import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import React, { useCallback, useEffect, useState } from 'react'

import { getLogoCacheVersion } from 'components/header/BusinessLogo'
import Constants from 'Constants'

const { PUBLIC_ASSETS_BUCKET_NAME, STORAGE_PATH, MEDIA_SERVER } = Constants
const DEFAULT_LOGO_PATH = `${MEDIA_SERVER}HeaderLogo.png`

interface SelectItemContentProps {
  businessId?: string
  businessTitle?: string
}

const SelectItemContent = ({ businessId, businessTitle }: SelectItemContentProps) => {
  const [version, setVersion] = useState(getLogoCacheVersion)

  useEffect(() => {
    const handler = () => setVersion(getLogoCacheVersion())
    window.addEventListener('hh-logo-cache-invalidated', handler)
    return () => window.removeEventListener('hh-logo-cache-invalidated', handler)
  }, [])

  const handleError = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.onerror = null
    e.currentTarget.src = DEFAULT_LOGO_PATH
  }, [])

  return (
    <>
      <ListItemAvatar
        sx={{
          display: 'flex',
          alignItems: 'center',
          minWidth: 60,
          width: 60,
          height: 40,
          img: { maxWidth: '100%' },
        }}
      >
        <img
          alt=""
          src={`${STORAGE_PATH}${PUBLIC_ASSETS_BUCKET_NAME}/${businessId}/business_logo.png?v=${version}`}
          onError={handleError}
        />
      </ListItemAvatar>
      <ListItemText
        primary={businessTitle}
        slotProps={{
          primary: { noWrap: true, variant: 'h6', fontWeight: 400 },
        }}
        sx={{ ml: 1 }}
      />
    </>
  )
}

export default SelectItemContent
